'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _level = require('../actions/level');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Component) {
    var Level = _react2.default.createClass({
        displayName: 'Level',

        propTypes: {
            levels: _react.PropTypes.object.isRequired,
            dispatch: _react.PropTypes.func.isRequired
        },
        componentWillMount: function componentWillMount() {
            var _props = this.props,
                dispatch = _props.dispatch,
                filter = _props.filter;

            dispatch((0, _level.fetchLevelsIfNeeded)(filter));
        },
        render: function render() {
            return _react2.default.createElement(Component, this.props);
        }
    });

    var mapStateToProps = function mapStateToProps(store) {
        var levels = store.level.levels;

        return {
            levels: levels
        };
    };

    return (0, _reactRedux.connect)(mapStateToProps)(Level);
};


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/with_levels.js
// module id = 1328
// module chunks = 0